import { render } from "./TableListCriterion.vue?vue&type=template&id=3bd9509d&scoped=true&ts=true"
import script from "./TableListCriterion.vue?vue&type=script&lang=ts"
export * from "./TableListCriterion.vue?vue&type=script&lang=ts"

import "./TableListCriterion.vue?vue&type=style&index=0&id=3bd9509d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd9509d"]])

export default __exports__